import React, { Component } from 'react';
import ReactTimeAgo from 'react-time-ago';
import '../../styles/css/users/Profile.css';
import StarRateIcon from '@material-ui/icons/StarRate';
import StarRatingComponent from 'react-star-rating-component';

class UserReviews extends Component {
    constructor(props) {
        super(props);
        this.state = {
            
        }
    }

    componentDidMount() {
    }

    render() {

        const timeZoneDiff = new Date().getTimezoneOffset();
        const { reviews } = this.props;

        return (

            <div className="projectCardRoot">
                <div className="commentHistoryDiv">
                    {
                        reviews.length > 0 ?
                            reviews.map(review => {
                                return (
                                    <div className="commentHistoryBody" key={review.id}>
                                        <div className="mobileCommentsDeck">
                                            <div className="commentTime">
                                                <ReactTimeAgo
                                                    date={
                                                        timeZoneDiff >= 0 ?
                                                            new Date(new Date(review.date.date).getTime() - timeZoneDiff * 60000)
                                                            :
                                                            new Date(new Date(review.date.date).getTime() - timeZoneDiff * 60000)
                                                    }
                                                />
                                            </div>
                                            <div className="commenterName">@{review.placed_user}</div>
                                        </div>
                                        <div className="commentTextMain">
                                            <div className="commenterColor" style={{ backgroundColor: (review.user_role === 2 || review.user_role === 3) ? "#31c680" : "#97ddff" }}></div>
                                            <div>
                                                <div className="reviewText">{review.description}</div>
                                                <div>
                                                    <StarRatingComponent
                                                        name="rate1"
                                                        starCount={5}
                                                        value={Math.round(review.rating)}
                                                        starColor={"#9cd5f1"}
                                                        emptyStarColor={"#b1b1b1"}
                                                        renderStarIcon={() => <StarRateIcon />}
                                                        editing={false}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                            :
                            <div className="noReviewsDiv">No reviews</div>
                    }
                </div>
            </div>
        )
    }
}

export default UserReviews;


// WEBPACK FOOTER //
// ./src/pages/Users/UserReviews.js